<template>
    <div class="news-detail-wrap">
        <page-nav :navlist="NAVLIST"></page-nav>
        
        <div class="news-detail-container">
            <div class="news-detail-box" v-if="newsData">
                <div class="news-detail-header">
                    <span class="news-detail-tag">{{ tagMap[newsData.category] }}</span>
                    <span class="news-detail-title">{{ newsData.title }}</span>
                </div>
                <div class="news-detail-time">
                    <span class="label">アークナイツ運営　Updated</span>
                    <span class="time">{{ $utils.formatTime(newsData.publishedAt) }}</span>
                </div>
                <div class="news-detail-content" v-html="newsData.content[0].value">
                </div>
                <div class="news-info">
                    <p class="label">アークナイツ運営</p>
                    <p class="time">{{ $utils.formatTime(newsData.publishedAt) }}</p>
                </div>
                
                <div class="to-top" v-show="btnFlag" @click="toTop">
                    <i class="iconfont iconshang-jiantou"></i>
                </div>
            </div>
        </div>
        <footer-bar></footer-bar>
    </div>
</template>

<script>
import pageNav from "../components/Nav"
import {mapState, mapGetters} from 'vuex'
import FooterBar from "../components/Footer";

export default {
    name: "newsDetail",

    components: {
        FooterBar,
        pageNav
    },
    data: () => ({
        tagList: [
            {
                id: 1,
                text: 'お知らせ'
            },
            {
                id: 2,
                text: 'イベント'
            },
            {
                id: 3,
                text: 'アップデート'
            },
            {
                id: 4,
                text: 'メンテナンス'
            }
        ],
        
        newsId: 0,
        newsData: '',

        scrollTop: 0,
        btnFlag: false,
    }),
    created() {
        this.newsId = this.$route.params.newsid
        if(process.env.VUE_APP_ENV !== 'online' && this.newsId === 'preview' && this.$route.query.userToken) {
            this.getNewsPreview(this.$route.query.userToken)
        } else {
            this.getNewsDetail()
        }

        if(this.FULLPAGE) {
            this.FULLPAGE.fullScrollDisable(true)
            this.FULLPAGE.bodyScrollable(true)
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop)
    },
    watch: {

    },
    computed: {
        ...mapState({
            NAVLIST: state => state.Home.NAVLIST,
            FULLPAGE: state => state.Home.FULLPAGE
		}),
        tagMap() {
            let map = {}
            for(let i = 0, len = this.tagList.length; i < len; i++) {
                map[this.tagList[i].id] = this.tagList[i].text
            }
            return map
        },
    },
    methods: {
        getNewsDetail() {
            this.axios.get(`${process.env.VUE_APP_NEWS_HOST}/news/detail`, {
                params: {
                    id: this.newsId,
                }
            }).then(v => {
                this.newsData = v.data.items[0]
            }).catch(e => {
                console.log(e)
            })
        },
        getNewsPreview(userToken) {     // 预览查看
            this.axios.get(`${process.env.VUE_APP_NEWS_HOST}/news/detail`, {
                params: {
                    userToken
                }
            }).then(v => {
                this.newsData = v.data.items[0]
            }).catch(e => {
                console.log(e)
            })
        },
        toTop() {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 0) {
                that.btnFlag = true
            } else {
                that.btnFlag = false
            }
        }
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
};
</script>

<style lang="scss" scoped>
.news-detail-wrap {

    &::after {
        content: '';
        position: fixed;
        z-index: -1;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: url("../assets/images/home/news/bg.jpg") no-repeat;
        background-size: cover;
        background-position: center top;
    }

    .news-detail-container {
        position: relative;
        width: 100%;
        min-height: 100vh;

        .news-detail-box {
            position: relative;
            width: 75%;
            margin: pxTorem(30px) auto;
            background: #141516;
            box-sizing: border-box;
            border-right: 2px solid #fe2;
            padding: pxTorem(30px) pxTorem(50px);

            .news-detail-header {
                width: 100%;
                box-sizing: border-box;
                padding: 0 pxTorem(30px);
                font-size: pxTorem(30px);
                font-weight: bold;
                display: flex;
                margin-bottom: pxTorem(20px);

                .news-detail-tag {
                    color: #22bbff;
                    margin-right: pxTorem(20px);
                }
                .news-detail-title {
                    flex: 1;
                    color: #fff;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .news-detail-time {
                font-size: pxTorem(16px);
                text-align: right;
                
                .label {
                    color: #c4c4c4;
                    margin-right: pxTorem(5px);
                }
                .time {
                    color: #22bbff;
                }
            }
            .news-detail-content {
                box-sizing: border-box;
                position: relative;
                margin-top: pxTorem(20px);
                box-sizing: border-box;
                padding: pxTorem(20px) pxTorem(30px);
                min-height: pxTorem(800px);
                color: #fff;

                &::before {
                    content: "";
                    display: block;
                    width: 5%;
                    height: 4px;
                    background:  #fff;
                    position: absolute;
                    top: 0;
                    left: 0;
                    transform: translateY(-50%) translateZ(0);
                }
                &::after {
                    content: "";
                    display: block;
                    width: 94%;
                    height: 1px;
                    border-radius: 3px;
                    background:  #898989;
                    position: absolute;
                    top: 0;
                    right: 0;
                    transform: translateY(-50%);
                }

                & ::v-deep * {
                    color: #c4c4c4;
                    font-size: pxTorem(20px);
                }
                & ::v-deep img {
                    max-width: 100%;
                }
                & ::v-deep a {
                    color: #fe2;
                }
                & ::v-deep h1 {
                    font-size: pxTorem(32px);
                    margin: 0;
                    * {
                        font-size: inherit;
                    }
                }
                & ::v-deep h2 {
                    font-size: pxTorem(30px);
                    margin: 0;
                    * {
                        font-size: inherit;
                    }
                }
                & ::v-deep h3 {
                    font-size: pxTorem(28px);
                    margin: 0;
                    * {
                        font-size: inherit;
                    }
                }
                & ::v-deep h4 {
                    font-size: pxTorem(26px);
                    margin: 0;
                    * {
                        font-size: inherit;
                    }
                }
                & ::v-deep h5{
                    font-size: pxTorem(24px);
                    margin: 0;
                    * {
                        font-size: inherit;
                    }
                }
                & ::v-deep h6 {
                    font-size: pxTorem(22px);
                    margin: 0;
                    * {
                        font-size: inherit;
                    }
                }
            }
            .news-info {
                color: #c4c4c4;
                text-align: right;
                font-size: pxTorem(20px);

                .label {
                    margin-bottom: pxTorem(10px);
                }
                .time {
                }
            }
            .to-top {
                position: absolute;
                left: 102%;
                bottom: 2%;
                width: pxTorem(45px);
                height: pxTorem(45px);
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0;
                transition: all .3s ease-in-out;

                i {
                    color: #fff;
                    font-size: pxTorem(20px);
                }

                &:hover {
                    background: #fe2;
                }
            }
        }
    }
}
</style>
